import { render, staticRenderFns } from "./RedFlagModal.vue?vue&type=template&id=bf503494&scoped=true"
import script from "./RedFlagModal.vue?vue&type=script&lang=js"
export * from "./RedFlagModal.vue?vue&type=script&lang=js"
import style0 from "./RedFlagModal.vue?vue&type=style&index=0&id=bf503494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf503494",
  null
  
)

export default component.exports